import { Dialog } from '@servicetitan/anvil2';
import {
    ExternalApplicationResponse,
    LoanApplicationSubmitSource2,
} from '@servicetitan/financing-api-client';
import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';
import { SubmittingUserStore } from '../application';
import { ExternalApplicationFormDialog } from './ExternalApplicationFormDialog';

interface FullApplicationFormDialogProps {
    open: boolean;
    onClose: () => void;
    onApplicationOpened: (response?: ExternalApplicationResponse) => void;
}

/**
 * Self-contained dialog for showing external application forms in places other than
 * the plan selection screen. Used in e.g. WF prequal decline screens to let the
 * user submit a full application.
 */
export const FullApplicationFormDialog = ({
    open,
    onClose,
    onApplicationOpened,
}: FullApplicationFormDialogProps) => {
    const { submittingUser } = SubmittingUserStore.useStore();
    const { setupData } = SetupDataStore.useStore();
    const providerConfig = useProviderConfig();
    const screenSize = useBreakpoint();
    const isNarrowScreen = screenSize.isXs || screenSize.isSm;

    const isTechnician = setupData?.role === 'technician';
    const source = isTechnician
        ? LoanApplicationSubmitSource2.Mobile
        : LoanApplicationSubmitSource2.OnlineEstimates;

    if (!open) {
        return null;
    }

    return (
        <Dialog
            open
            size="large"
            fullScreen={isNarrowScreen}
            onClose={onClose}
            disableCloseOnClickOutside
        >
            <ExternalApplicationFormDialog
                onSendViaEmail={() => {}}
                onOpenApplication={response => onApplicationOpened(response)}
                onCancel={onClose}
                allowSendViaEmail={providerConfig.allowSendViaEmail ?? false}
                showTechnicianInstructions={isTechnician}
                submittingUser={submittingUser}
                source={source}
                isPrequalification={false}
                submitButtonText="Apply Now"
                showLaunchIcon
            />
        </Dialog>
    );
};
